import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Box, Typography } from '@mui/material';
import { StoreApi } from '../../api/storeApi';

const styles = {
  autocomplete: {
    width: 250,
  },
  optionBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  nameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  statusDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginLeft: 8,
  },
};

const StoreSelect = ({ selectedStore, onChange, label = 'Search Store' }) => {
  const [stores, setStores] = useState([]);

  useEffect(() => {
    const fetchStores = async () => {
      const response = await StoreApi.getStores({ page: -1 });
      setStores(response.data.data);
    };
    fetchStores();
  }, []);

  const getOptionLabel = (store) => store?.name || '';

  const renderOption = (props, option) => (
    <Box component="li" {...props}>
      <Box sx={styles.optionBox}>
        <Typography sx={styles.nameText}>{option.name}</Typography>
        <Box
          sx={{
            ...styles.statusDot,
            backgroundColor: option.is_live ? 'green' : 'red',
          }}
        />
      </Box>
    </Box>
  );

  return (
    <Autocomplete
      disablePortal
      size="small"
      id="stores"
      options={stores}
      getOptionLabel={getOptionLabel}
      value={selectedStore}
      onChange={onChange}
      sx={styles.autocomplete}
      renderOption={renderOption}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};

export default StoreSelect;